import { render } from "./AlertModal.vue?vue&type=template&id=b03f4bac&scoped=true"
import script from "./AlertModal.vue?vue&type=script&lang=js"
export * from "./AlertModal.vue?vue&type=script&lang=js"

import "./AlertModal.vue?vue&type=style&index=0&id=b03f4bac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b03f4bac"]])

export default __exports__